import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";


@Component({
    selector: 'app-sanierung-co2costs',
    templateUrl: './sanierung-co2costs.component.html'
})
export class SanierungCo2costsComponent implements OnInit, OnDestroy {

  /**
   * The co2 costs that should be displayed
   */
  @Input() co2Costs: {current: number, sanitized: number};

  /**
   * Eventemitter that fires every time the costs are changing.
   */
  @Input() co2CostChanges: EventEmitter<any>

  /**
   * remember the subscriptions, so we can unsubscribe after leaving the component.
   */
  subscriptions: Subscription[] = [];

  /**
   * toggle for the help
   */
  showHelp: boolean = false;

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    if(this.co2CostChanges) {
      this.co2CostChanges.subscribe(costs => this.co2Costs = costs.co2);
    }
  }

  /**
   * @inheritDoc
   */
  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  /**
   * calculates the savings bar heigt, based on the saved co2 amount
   */
  getBarHeight(): number {
    if(!this.co2Costs) {
      return;
    }
    const percentage = this.co2Costs.sanitized / this.co2Costs.current;
    if(percentage > 1) {
      // no saving
      return (Math.min(1.2, percentage) * 100);
    }

    // saving, value below 100%
    return (Math.max(0, percentage) * 100);
  }

}
